export const environment = {
  production: true,
  baseUrl: '/api',
  supportEmail: 'empowerment.support@au.ey.com',
  internalSiteHelp: 'https://sites.ey.com/sites/Empowerment',
  // set to -1 for unlimited history
  undoHistoryCount: 25,
  showErrorDialog: false,
  froalaKey: 're1H1qB2B1C6A6E5G4D4A1FrjifLUQZf1ASFb1EFRNh1Hb1BCCQDUHnA8B6E5D5B1C3A2A1C8D8==',
};
